// extracted by css-extract-rspack-plugin
export default {"checksButton":"ChecksStatusButton-module__checksButton__bVEgW","checksCountText":"ChecksStatusButton-module__checksCountText__gxMKI"};